import { Controller } from "stimulus";
import Rails from "@rails/ujs";

export default class extends Controller {
  static targets = ["form", "submitButton", "fileInput", "titleInput"];

  static outlets = ["scorm-cloud-courses--update", "scorm-cloud-courses--create"];

  static values = {
    errorMessage: String,
    postbackUrl: String,
    usePostbackParam: Boolean
  };

  connect() {
    this.boundForm = this.handleFormSubmit.bind(this);
    this.formTarget.addEventListener("submit", this.boundForm);
  }

  disconnect() {
    this.formTarget.removeEventListener("submit", this.boundForm);
  }

  async handleFormSubmit(event) {
    event.preventDefault();

    this._disableSubmitButton();

    const hasFile = this.fileInputTarget.files.length > 0;
    const hasTitle = this.titleInputTarget.value.trim() !== "";
    // 'patch' methods appear as 'post' in the form element, so we use the dataset
    const method = this.formTarget.dataset.method?.toLowerCase();

    // if no file is selected, but the title is present, submit the form without the upload
    // only when updating an existing course (patch)
    if (!hasFile && hasTitle && method === "patch") {
      this._handleSubmitWithoutUpload();
    } else if (hasFile) {
      this._handleByMethodType(method);
    }
  }

  _handleByMethodType(method) {
    if (method === "patch") {
      this._handleUpdateWithFile(); // update existing course with file
    } else if (method === "post") {
      this.handleCourseCreation(); // create new course with file
    }
  }

  async _getAuthToken() {
    return new Promise((resolve, reject) => {
      Rails.ajax({
        url: "/admin/scorm_cloud_courses/auth_token",
        type: "GET",
        dataType: "json",
        success: (data) => {
          resolve(data.result);
        },
        error: (xhr, status, error) => {
          reject(error);
        }
      });
    });
  }

  _handleSubmitWithoutUpload() {
    if (this.hasScormCloudCoursesUpdateOutlet) {
      this.scormCloudCoursesUpdateOutlet.softUpdate(this.formTarget);
    }
  }

  async _handleUpdateWithFile() {
    if (this.hasScormCloudCoursesUpdateOutlet) {
      const authToken = await this._getAuthToken();
      this.scormCloudCoursesUpdateOutlet.uploadAndUpdateCourse(
        authToken, this.formTarget, this._params()
      );
    }
  }

  handleCourseCreation() {
    if (this.hasScormCloudCoursesCreateOutlet) {
      this.scormCloudCoursesCreateOutlet.createAndUpload(this.formTarget, this._params());
    }
  }

  _params() {
    return {
      usePostbackParam: this.usePostbackParamValue,
      postbackUrl: this.postbackUrlValue,
      uploadUrl: this.fileInputTarget.dataset.url,
      errorMessage: this.errorMessageValue
    }
  }

  _disableSubmitButton() {
    this.submitButtonTarget.disabled = true;
  }
}
